import type { FaireThemeEntity } from "../../entity_types/theme";

export const curated_holistic_wellness: FaireThemeEntity = {
  token: "curated-holistic-wellness",
  type: "theme",
  name: "Curated Holistic Wellness",
  description: "Targeted wellness solutions and recovery tools addressing specific physiological needs.",
  teaser: "Beyond basic aromatherapy -- targeted wellness your customers are searching for.",
  detail: "Your frequent orders of lymphatic lotions, nerve pain salves, and hormone support oils show deep engagement with specific health modalities. Your search queries for wellness tracker and liver qi stagnation confirm this.",
  bgColor: "#EDE0F5",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_mnxxywbn3z",
    "p_7oeiyp5ydy",
    "p_dbxjm7aewk",
    "p_ehg9ec3zel",
    "p_f4dj444q7z",
    "p_1tsy5qe3zu",
    "p_w2ckw5h3t9",
    "p_n9fbpd42gp",
    "p_kve2xq463g",
    "p_6lbg51g67p",
    "p_34zcssfjxg",
    "p_ff5xm4sfh8",
    "p_2kvw6k2z84",
    "p_zzsydxceff",
    "p_knq4rsj58d",
    "p_s2z7vf4tre",
    "p_737fzcnwtn",
    "p_99fbrve9qv",
    "p_vymdwwc8a5",
    "p_xbn7tgxn7e",
    "p_q6cv5bju49",
    "p_r9m8a2uvyg",
    "p_ns2k5z2ujj",
    "p_umd8qrvq5z",
    "p_eyus4ka3es",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
